import Swal from 'sweetalert2'
import Vuex from './vuex'
import { useError } from '@/composables'

class Api {
	axios = null

	constructor() {}

	call(requestType, url, data = null, opts = {}) {
		this.axios = window.axios.create()

		delete this.axios.defaults.headers.common['X-Socket-Id']

		if (opts.for_app) {
			delete this.axios.defaults.headers.common['Authorization']
			delete this.axios.defaults.headers.common['X-Requested-With']
		}

		return new Promise((resolve, reject) => {
			this.axios[requestType](url, data, opts)
				.then(response => {
					resolve(response)
				})
				.catch(({ response }) => {
					if (!response) {
						Swal.fire({
							icon: 'error',
							title: 'Erro!',
							text: 'Ocorreu um erro ao realizar sua solicitação. Contate o suporte!',
						})

						reject()
					}

					if (response.status === 429) {
						useError(
							'Muitas tentativas em pouco tempo, aguarde alguns minutos e tente novamente!'
						)

						reject()
					}

					if ([401, 418].indexOf(response.status) > -1) {
						new Vuex().dispatch('auth/Logout').finally(() => {
							reject(response)
						})
					}

					resolve(response)
				})
		})
	}
}

export default Api
